import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Collapse } from "react-bootstrap";

import { find } from "lodash";

import * as codeActions from "../../actions/codeActions";
import * as modalActions from "../../actions/modalActions";

import CodeList from "./CodeList";
import CodeForm from "./CodeForm";
import HeaderWrapper from "../common/HeaderWrapper";
import Modal from "../common/Modal";
import ConfirmModal from "../common/ConfirmModal";

class CodePage extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      code: {},
      open: false,
      adding: false
    };
  }

  componentDidMount = () => {
    this.props.actions.loadCodes();
  };

  onClickAdd = () => {
    this.setState({ code: {}, open: !this.state.open, adding: true });
  };

  onClickEdit = (id) => {
    const code = find(this.props.codes, { id });
    this.setState({ code, adding: false });
    this.props.actions.getCode(id, true);
  };

  onClickDelete = (id) => {
    this.props.actions.requestCodeId(id);
  };

  handleAdd = (code) => {
    this.props.actions.createCode(code);
    this.setState({ open: false });
  };

  handleSave = (code) => {
    this.props.actions.updateCode(code);
  };

  handleDelete = () => {
    this.props.actions.deleteCode(this.props.codeToDelete);
  };

  render() {
    const { code } = this.state;

    const codeForm = (
      <CodeForm
        code={code}
        codes={this.props.codes}
        onAdd={this.handleAdd}
        onSave={this.handleSave}
        onCancel={this.props.actions.hideModal}
        saving={this.props.savingCode}
        adding={this.state.adding}
        editing
      />
    );

    return (
      <>
        <HeaderWrapper
          breadcrumbs={[{ label: "Settings" }, { label: "System Codes" }]}
          onClickAdd={this.onClickAdd}
        />
        <div>
          <Collapse in={this.state.open}>
            <div>
              <div className="content-wrapper">
                <h4>Add Code</h4>
                {codeForm}
              </div>
            </div>
          </Collapse>
        </div>
        <div className="content-wrapper">
          <CodeList
            codes={this.props.codes}
            onClickEdit={this.onClickEdit}
            onClickDelete={this.onClickDelete}
          />
          <Modal
            id="codeDetailsModal"
            title="Code Info"
            body={codeForm}
            close={this.props.actions.hideModal}
          />
          <ConfirmModal
            id="codeDeleteModal"
            title="Delete Code"
            body="Are you sure you want to delete this code?"
            close={this.props.actions.hideModal}
            confirm={this.handleDelete}
          />
        </div>
      </>
    );
  }
}

CodePage.propTypes = {
  actions: PropTypes.object,
  savingCode: PropTypes.bool,
  codeToDelete: PropTypes.string,
  codes: PropTypes.array.isRequired
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,

    savingCode: state.reducers.savingCode,
    code: state.reducers.code,
    codes: state.reducers.codes,
    codeToDelete: state.reducers.codeToDelete
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...modalActions, ...codeActions }, dispatch)
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(CodePage);
